
import { defineStore } from "pinia"
import { ref } from 'vue'
import { useApiStore, apiIdOf, API_ORIGIN, axiosRetryx } from "@/stores/api"
import { apiDefaultDescriptions, type ApiOptions } from "@/stores/api"

export const useBannersStore = defineStore('banners', () => {
  type BannerInfo = {
    image_url: string
    link_url: string
    image_url2: string | null
    link_url2: string | null
    background_color_code: string
  }

  const { apiCall, checkResponseError } = useApiStore()
  const bannerImageUrl = ref<string>('')
  const bannerLinkUrl = ref<string>('')
  const bannerImageUrl2 = ref<string>('')
  const bannerLinkUrl2 = ref<string>('')
  const backgroundColorCode = ref<string | null>(null)

  /** バナー情報取得API */
  const getBannerInfo = async (args: { __apiOptions?: ApiOptions }) =>  {
    const apiOptions = args.__apiOptions || {}
    apiOptions.apiId = apiIdOf('getBannerInfo');

    return await apiCall<BannerInfo>(apiOptions, async (apiConfig) => {
      const url = API_ORIGIN + "/getbannerinfo";
      const data = {
      }

      const response = await axiosRetryx({ method: 'post', url, data, ...apiConfig })

      const descriptions = {
        ...apiDefaultDescriptions,
      }

      if (checkResponseError(response, descriptions, apiOptions)) {
        return;
      }
      return response.data.banner_info;
    })
  }

  const initBanner = async () => {
    // バナー情報を取りに行く
    const args = { __apiOptions: { noErrorDialog: true, noDisplayLoading: true } }
    const bannerInfo = await getBannerInfo(args)
    if(bannerInfo) {
      bannerImageUrl.value = bannerInfo.image_url
      bannerLinkUrl.value = bannerInfo.link_url
      bannerImageUrl2.value = bannerInfo.image_url2 ?? ''
      bannerLinkUrl2.value = bannerInfo.link_url2 ?? ''
      backgroundColorCode.value = bannerInfo.background_color_code
      return;
    }
    // エラーの場合
    bannerImageUrl.value = ''
    bannerLinkUrl.value = ''
    bannerImageUrl2.value = ''
    bannerLinkUrl2.value = ''
    backgroundColorCode.value = null
  }

  return {
    bannerImageUrl,
    bannerLinkUrl,
    bannerImageUrl2,
    bannerLinkUrl2,
    backgroundColorCode,
    initBanner,
  }
})
